var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.395 13.454H4.604a1.5 1.5 0 0 1-1.498-1.498V5.164a1.5 1.5 0 0 1 1.498-1.498h6.791a1.5 1.5 0 0 1 1.498 1.498v6.792a1.5 1.5 0 0 1-1.498 1.498zm-6.791-8.79a.5.5 0 0 0-.5.5v6.792a.5.5 0 0 0 .5.5h6.791a.5.5 0 0 0 .5-.5V5.164a.5.5 0 0 0-.5-.499H4.604zM2.107 9.46h-.5a.5.5 0 0 1-.499-.5V2.17a.5.5 0 0 1 .5-.5h6.791a.5.5 0 0 1 .5.5v.473h.998v-.474A1.5 1.5 0 0 0 8.4.67H1.608A1.5 1.5 0 0 0 .109 2.168V8.96a1.5 1.5 0 0 0 1.499 1.498h.499v-.999z"
  })));
};
export default SvgCopy;